const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['day', 86_400_000],
  ['hour', 3_600_000],
  ['minute', 60_000],
];

const format = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

/** "3 hours ago", "2 days ago" or "just now" for a past timestamp. */
export const timeAgo = (iso: string | undefined, now = Date.now()) => {
  if (!iso) return undefined;
  const elapsed = now - new Date(iso).getTime();
  if (!Number.isFinite(elapsed)) return undefined;
  for (const [unit, ms] of UNITS) {
    if (elapsed >= ms) return format.format(-Math.floor(elapsed / ms), unit);
  }
  return 'just now';
};

export const ageMs = (iso: string | undefined | null, now = Date.now()) =>
  iso ? now - new Date(iso).getTime() : Number.NaN;

export const HOUR_MS = 3_600_000;
export const DAY_MS = 24 * HOUR_MS;
